import { useEffect, useState } from "react";
import { getTecnologias } from "services/Reports";
import { Table } from "antd";
import ExportExcel from "components/excel/ExportExcel";
import Loader from "components/loader";
import dayjs from "dayjs";

const Technologies = () => {
  const [tecnologias, setTecnologias] = useState([]);
  const [dataExcel, setDataExcel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTecnologias = async () => {
    try {

      setIsLoading(true)
      const data = await getTecnologias()

      setIsLoading(false)

      if (data) {
        setTecnologias(data[0]);
        dataExport(data[0])
      }

    } catch (error) {
      return error
    }
  }

  const columns = [
    {
      title: 'User_ID',
      dataIndex: 'user_id',
    },
    {
      title: 'Username',
      dataIndex: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
    },
    {
      title: 'Apellido',
      dataIndex: 'apellido',
    },
    {
      title: 'Tecnología',
      dataIndex: 'field',
      sorter: (a, b) => a.field - b.field,
    },
    {
      title: 'Level',
      dataIndex: 'level',
      sorter: (a, b) => a.level - b.level,
    },
    {
      title: 'Fecha Nacimiento',
      dataIndex: 'fecha_nac',
      sorter: (a, b) => dayjs(a.fecha_nac).unix() - dayjs(b.fecha_nac).unix(),
      render: (text) => dayjs(text).format('DD/MM/YYYY'),
    },
    {
      title: 'Edad',
      dataIndex: 'Edad',
      sorter: (a, b) => a.Edad - b.Edad,
    },
    {
      title: 'Género',
      dataIndex: 'Genero',
      sorter: (a, b) => a.Genero - b.Genero,
    },
    {
      title: 'Localidad',
      dataIndex: 'localidad',
    },
    {
      title: 'Provincia',
      dataIndex: 'provincia',
    },
  ];

  const dataExport = (data) => {
    const exportData = data.map((item) => {
      return {
        'User_ID': item.user_id,
        'Username': item.name,
        'Email': item.email,
        'Nombre': item.nombre,
        'Apellido': item.apellido,
        'Tecnología': item.field,
        'Level': item.level,
        'Fecha de nacimiento': dayjs(item.fecha_nac).format('DD/MM/YYYY'),
        'Edad': item.Edad,
        'Género': item.Genero,
        'Localidad': item.localidad,
        'Provincia': item.provincia,
      }
    })

    setDataExcel(exportData)
  }

  useEffect(() => {
    fetchTecnologias()
  }, [])

  return (
    <>
      <div className="flex flex-row gap-5">
        <h1 className="text-3xl font-medium mb-5">/ Tecnologías</h1>
        <ExportExcel data={dataExcel} fileName={"Tecnologias_" + new Date().toLocaleDateString()} title="Descargar Excel" />
      </div>

      {isLoading ? <Loader /> :
        <Table
          columns={columns}
          dataSource={tecnologias}
          loading={isLoading}
          onChange={(pagination, filters, sorter, extra) => {
            dataExport(extra.currentDataSource)
          }}
        />
      }
    </>
  );
};

export default Technologies;
